//For Live Projects
window.onload = function () {
    document.querySelector('body').classList.add("loaded")
  }();
